export interface AveliosSettings {
  imageDownload: string;
  graphqlEndpoint: string;
  graphqlEndpointSubscriptions: string;

  securedRoutes: string[];
}

export const defaultSettings: AveliosSettings = {
  graphqlEndpoint: process.env.NEXT_PUBLIC_GQL_URL ?? 'http://10.63.0.105:9131/graphql',
  graphqlEndpointSubscriptions:
    process.env.NEXT_PUBLIC_GQL_WS_URL ?? 'ws://10.63.0.105:9131/subscriptions',
  imageDownload: process.env.NEXT_PUBLIC_IMAGE_URL ?? 'http://80.81.14.115:9131/download/image',
  securedRoutes: [
    '/appointments',
    '/appointments/appointment',
    '/documents',
    '/appointment-confirmation',
    '/appointment-success',
    '/user',
  ],
};
